import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// #2496 — `shadow-button` and `shadow-button-press` are custom shadow sizes
// (tailwind.config.ts). Registered in the shadow group, so a caller's
// `shadow-none` or `shadow-sm` replaces the Button's own shadow.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      shadow: [{ shadow: ["button", "button-press"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
